import { CIcon } from '~/icons/types'

export const ciCompare: CIcon = {
  width: '18',
  height: '18',
  paths: [
    {
      d:
        'M8.75 9.668c0-.083-.084-.167-.167-.25-.083-.083-.167-.083-.25-.167-.083 0-.167-.083-.333-.083H3.667c-.5 0-.834.333-.834.833 0 .5.333.834.833.834H6L.917 15.918a.805.805 0 0 0 0 1.167c.166.166.333.25.583.25.25 0 .417-.084.583-.25L7.166 12v2.334c0 .5.334.833.834.833.5 0 .833-.333.833-.833V10c0-.166 0-.25-.083-.333Zm8.333-8.75a.806.806 0 0 0-1.166 0l-5.084 5.083V3.668c0-.5-.333-.833-.833-.833-.5 0-.834.333-.834.833v4.333c0 .084 0 .25.084.334 0 .083.083.166.166.25.084.083.167.083.25.166.084 0 .167.084.334.084h4.333c.5 0 .833-.334.833-.834 0-.5-.333-.833-.833-.833H12l5.083-5.083a.806.806 0 0 0 0-1.167Z',
      fill: '#fff'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'compare',
  type: 'regular'
}
